function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: inherit;\n  font-size: 0.8rem;\n  font-style: italic;\n  text-transform: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { Typography } from "antd";
import styled from "styled-components";
var Text = Typography.Text;
var Emphasis = styled(Text)(_templateObject());
export default Emphasis;
